import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Product } from '../models';
import { SupportComponent } from '../support/support.component';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss'],
})
export class PaymentSuccessComponent implements OnInit {
    @Input()
    successUrl = '';

    @Input()
    product: Product;

    constructor(private modalService: NgbModal) {}

    ngOnInit() {}

    openSupportModal() {
        const modalRef = this.modalService.open(SupportComponent, {
            backdrop: 'static',
        });

        modalRef.componentInstance.name = 'PaymentSupport';
    }
}
